export default __webpack_public_path__ + "static/media/avatar_grumpy_cat2.a129d767.mp3";